export enum UserGeneratedListGroup {
	PROCESS_FAILURES = 'process_failures',
	CANCELED_ORDERS = 'canceled_orders',
	TECHNICAL_FAILURES = 'technical_failures',
}
